/* Path (in Lyearn) -> Course (for DA)
Course (in Lyearn) -> Topic (For DA)
ILT (in Lyearn) -> Lecture (For DA)
ILT Session (in Lyearn) -> Session (For DA)
Checkpoint (in Lyearn) -> Task (For DA) */

const typeAlternates = {
  course: { plural: 'courses', alternate: 'topic', alternatePlural: 'topics' },
  ilt: { plural: 'ilts', alternate: 'lecture', alternatePlural: 'lectures' },
  path: { plural: 'paths', alternate: 'course', alternatePlural: 'courses' },
  session: { plural: 'sessions', alternate: 'session', alternatePlural: 'sessions' },
  checkpoint: { plural: 'checkpoints', alternate: 'task', alternatePlural: 'tasks' },
  'checkpoint review': {
    plural: 'checkpoint reviews',
    alternate: 'task review',
    alternatePlural: 'task reviews'
  }
};

const getCase = (type, typeCase, plural) => {
  let transformedType = '';

  if (typeCase === 'U') {
    // Uppercase
    transformedType = type.toUpperCase();
  } else if (typeCase === 'C') {
    // Capitalize
    transformedType = type.charAt(0).toUpperCase() + type.slice(1);
    if (transformedType.toLowerCase().indexOf('ilt') === 0) {
      transformedType = transformedType.toUpperCase();
    }
  } else {
    transformedType = type;
  }

  if (plural && plural.plural && plural.lowercaseS) {
    // last character lowercase
    transformedType =
      transformedType.slice(0, -1) + transformedType.substr(type.length - 1).toLowerCase();
  }
  return transformedType;
};

const getContentTypeName = (t, typeCase, plural = {}) => {
  if (!t) {
    return t;
  }
  const type = t.toLowerCase();
  if (
    window.__getFeatureFlagFunc ? !window.__getFeatureFlagFunc('alternate-content-name') : false
  ) {
    return getCase(
      plural.plural ? (typeAlternates[type] ? typeAlternates[type].plural : type) : type,
      typeCase,
      plural
    );
  }
  const transformedType = getCase(
    typeAlternates[type]
      ? plural.plural
        ? typeAlternates[type].alternatePlural
        : typeAlternates[type].alternate
      : type,
    typeCase,
    plural
  );

  return transformedType;
};

const contentType = getContentTypeName;
export { contentType };

export default getContentTypeName;
